import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Radio/radio';
import { css } from '@patternfly/react-styles';
export var Radio =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Radio, _React$Component);

  function Radio(props) {
    var _this;

    _classCallCheck(this, Radio);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Radio).call(this, props));

    _this.handleChange = function (event) {
      _this.props.onChange(event.currentTarget.checked, event);
    };

    if (!props.label && !props['aria-label']) {
      // eslint-disable-next-line no-console
      console.error('Radio:', 'Radio requires an aria-label to be specified');
    }

    return _this;
  }

  _createClass(Radio, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          ariaLabel = _a['aria-label'],
          checked = _a.checked,
          className = _a.className,
          defaultChecked = _a.defaultChecked,
          isLabelWrapped = _a.isLabelWrapped,
          isLabelBeforeButton = _a.isLabelBeforeButton,
          isChecked = _a.isChecked,
          isDisabled = _a.isDisabled,
          isValid = _a.isValid,
          label = _a.label,
          onChange = _a.onChange,
          description = _a.description,
          props = __rest(_a, ['aria-label', "checked", "className", "defaultChecked", "isLabelWrapped", "isLabelBeforeButton", "isChecked", "isDisabled", "isValid", "label", "onChange", "description"]);

      var inputRendered = React.createElement("input", Object.assign({}, props, {
        className: css(styles.radioInput),
        type: "radio",
        onChange: this.handleChange,
        "aria-invalid": !isValid,
        disabled: isDisabled,
        checked: checked || isChecked
      }, checked === undefined && {
        defaultChecked: defaultChecked
      }, !label && {
        'aria-label': ariaLabel
      }));
      var labelRendered = !label ? null : isLabelWrapped ? React.createElement("span", {
        className: css(styles.radioLabel, isDisabled && styles.modifiers.disabled)
      }, label) : React.createElement("label", {
        className: css(styles.radioLabel, isDisabled && styles.modifiers.disabled),
        htmlFor: props.id
      }, label);
      var descRender = description ? React.createElement("div", {
        className: css(styles.radioDescription)
      }, description) : null;
      var childrenRendered = isLabelBeforeButton ? React.createElement(React.Fragment, null, labelRendered, inputRendered, descRender) : React.createElement(React.Fragment, null, inputRendered, labelRendered, descRender);
      return isLabelWrapped ? React.createElement("label", {
        className: css(styles.radio, className),
        htmlFor: props.id
      }, childrenRendered) : React.createElement("div", {
        className: css(styles.radio, className)
      }, childrenRendered);
    }
  }]);

  return Radio;
}(React.Component);
Radio.defaultProps = {
  className: '',
  isDisabled: false,
  isValid: true,
  onChange: function onChange() {}
};